import {
  AnalyzedSelectedExpression,
  Expr,
  isColumnRef,
  isColumnEqualIgnoringPosition,
  ColumnRef,
} from 'common/types/soql';
import { getAllReferencedColumnNames } from './selectors';
import { toExpr, SelectionItem } from './soql-helpers';

export const doesArrayIncludeAnalyzedSelectedExpression = (
  s: AnalyzedSelectedExpression,
  arr: Expr[],
): boolean => {
  const unTypedExprS = toExpr(s.expr);
  if (isColumnRef(unTypedExprS)) {
    return arr.some((expr) =>
      isColumnRef(expr) ? isColumnEqualIgnoringPosition(expr, unTypedExprS) : false,
    );
  } else {
    return arr.some((expr) => getAllReferencedColumnNames(expr).includes(s.name));
  }
};

export const doesArrayIncludeAnalyzedSelectedExpressionNA = (s: SelectionItem, arr: Expr[]): boolean => {
  if (isColumnRef(s.expr)) {
    return arr.some((expr) => isColumnRef(expr) && isColumnEqualIgnoringPosition(expr, s.expr as ColumnRef));
  } else {
    return arr.some((expr) => getAllReferencedColumnNames(expr).includes(s.schemaEntry.name));
  }
};
